var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('div',{staticClass:"edit-content"},[_c('div',{staticClass:"edit-item edit-item2"},[_vm._v(" 添加套件之后，员工在填写审批单时，可直接下载excel模板并填写上传最多200条收款户名、账号类型、金额，审批人可以看到相应信息，审批通过后财务可以一键完成支付。 ")])])])
}]

export { render, staticRenderFns }